// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3NNda","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1LXcK"};